import { render, staticRenderFns } from "./ModelerApp.vue?vue&type=template&id=a354107e&"
import script from "./ModelerApp.vue?vue&type=script&lang=js&"
export * from "./ModelerApp.vue?vue&type=script&lang=js&"
import style0 from "./ModelerApp.vue?vue&type=style&index=0&id=a354107e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports